import UserStatus from "./user-status.component";

export default UserStatus;
